export interface User {
	id: string;
	username: string;
	displayName: string;
	avatarUrl: string;
	bio: string;
	projectCount: number;
	forkCount: number;
	totalRatings: number;
	averageRating: number;
	reputation: number;
	joinedAt: string;
}

export interface PrintSettings {
	material: string;
	nozzleTemp: number;
	bedTemp: number;
	layerHeight: number;
	infillPercent: number;
	printSpeed: number;
	supports: boolean;
	notes: string;
}

export interface PrintResult {
	id: string;
	projectId: string;
	userId: string;
	user: User;
	photoUrls: string[];
	rating: number;
	comment: string;
	createdAt: string;
}

export interface Project {
	id: string;
	title: string;
	description: string;
	creator: User;
	stlFileUrl: string;
	stlFileName: string;
	stlFileSize: number;
	thumbnailUrl: string;
	printSettings: PrintSettings;
	printResults: PrintResult[];
	averageRating: number;
	ratingCount: number;
	forkCount: number;
	forkedFromId: string | null;
	forkedFrom: { id: string; title: string; creator: string } | null;
	tags: string[];
	createdAt: string;
	updatedAt: string;
}

export type ProjectSortOption = "newest" | "top-rated" | "most-forked" | "most-printed";
export type MaterialType = "PLA" | "ABS" | "PETG" | "TPU" | "Nylon" | "Resin" | "Other";

export const MATERIALS: MaterialType[] = ["PLA", "ABS", "PETG", "TPU", "Nylon", "Resin", "Other"];
